import React from 'react';
import { Show } from '../../../../../shared/Show';
import { ToggleTW } from '../../../../../../tailwindComponents/toggleTW/ToggleTW';
import { useFormikContext } from 'formik';
import { IDetailsFormData } from './types/IDetailsFormData';
import { HybrydEventsTimeSelection } from './HybridEvents/HybridEventsTimeSelection';
import { RegularEventsTimeSelection } from './RegularEvents/RegularEventsTimeSelection';
import { DEFAULT_DSS_TIME_OPTION } from './utilities/generateTimeSlots';

const resetDssDates = (setFieldValue: any) => {
  setFieldValue('dssAppointmentOptions', []);
  setFieldValue('dssDateRangeStart', undefined);
  setFieldValue('dssDateRangeEnd', undefined);
  setFieldValue('dssDate', undefined);
  setFieldValue('dssStartTime', undefined);
  setFieldValue('dssEndTime', undefined);
  setFieldValue('isDssDateRange', false);
  setFieldValue('appointmentDate', undefined);
  setFieldValue('appointmentTime', undefined);
};

const getDefaultDssAppointmentOptions = (values: IDetailsFormData) => {
  return [
    {
      appointmentDate: values.isDssDateRange ? values.dssDateRangeStart : values.dssDate,
      appointmentTime: DEFAULT_DSS_TIME_OPTION.startTime,
    },
    {
      appointmentDate: values.isDssDateRange ? values.dssDateRangeEnd : values.dssDate,
      appointmentTime: DEFAULT_DSS_TIME_OPTION.endTime,
    },
  ];
};

// DateTimeSection Component
export const DateTimeSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IDetailsFormData>();
  const handleRangeToggle = (value: boolean) => {
    setFieldValue('signerSelectsFromRange', value);
    if (value) {
      setFieldValue('dssAppointmentOptions', getDefaultDssAppointmentOptions(values));
      setFieldValue('dssStartTime', DEFAULT_DSS_TIME_OPTION.startTime);
      setFieldValue('dssEndTime', DEFAULT_DSS_TIME_OPTION.endTime);
    } else {
      resetDssDates(setFieldValue);
    }
  };

  return (
    <section className="mb-5 mt-3">
      <div className="mb-3 text-base font-semibold leading-6">Appointment Details</div>

      <Show when={!!values.isDigitalScheduling}>
        <ToggleTW
          name="signerSelectsFromRange"
          text="Signer specifies date and time"
          className="mb-3"
          onChange={handleRangeToggle}
        />
      </Show>
      <Show when={!!values.signerSelectsFromRange} fallback={<RegularEventsTimeSelection />}>
        <HybrydEventsTimeSelection />
      </Show>
    </section>
  );
};
